import React from 'react'
import { StarOutline, StarFill } from '../Icons'
import ProgressBar from 'react-bootstrap/ProgressBar';
import './overAllRating.scss'
import StarRating from '../rating/StarRating';

const OverAllRating = ({data}) => {
    const userType = data?.userType
  
    return (
        <>
            <div className='overall-rating-wrap'>
                <div className='overall-rating-left'>
                    <div className='rating-number'>{userType === "provider" ? data?.ratingProvider !== null ? data?.ratingProvider : 0 : data?.ratingUser !== null ? data?.ratingUser : 0}/5</div>
                    <div className='w-100 text-center'>Over All</div>
                    <div className='rating'>
                    <StarRating size={14} rating={data?.ratingUser} />
                    </div>
                    <div className='w-100 text-center'>Based on Listing</div>
                </div>
                <div className='over-all-rating-right'>
                    <div className='rating-progress-row'>
                        <div className='rating'><StarFill /> <StarFill /> <StarFill /> <StarFill /> <StarFill /></div>
                        <div className='rating-progress'><ProgressBar variant='primary' now={userType === "provider" ? data?.starFive : data?.userStarFive} /></div>
                        <div className='progress-value'>{userType === "provider" ? data?.starFive : data?.userStarFive}</div>
                    </div>
                    <div className='rating-progress-row'>
                        <div className='rating'><StarFill /> <StarFill /> <StarFill /> <StarFill /> <StarOutline /></div>
                        <div className='rating-progress'><ProgressBar variant='primary' now={userType === "provider" ? data?.starFour : data?.userStarFour} /></div>
                        <div className='progress-value'>{userType === "provider" ? data?.starFour : data?.userStarFour}</div>
                    </div>
                    <div className='rating-progress-row'>
                        <div className='rating'><StarFill /> <StarFill /> <StarFill /> <StarOutline /> <StarOutline /></div>
                        <div className='rating-progress'><ProgressBar variant='primary' now={userType === "provider" ? data?.starThree : data?.userStarThree} /></div>
                        <div className='progress-value'>{userType === "provider" ? data?.starThree : data?.userStarThree}</div>
                    </div>
                    <div className='rating-progress-row'>
                        <div className='rating'><StarFill /> <StarFill /> <StarOutline /> <StarOutline /> <StarOutline /></div>
                        <div className='rating-progress'><ProgressBar variant='primary' now={userType === "provider" ? data?.starTwo : data?.userStarTwo} /></div>
                        <div className='progress-value'>{userType === "provider" ? data?.starTwo : data?.userStarTwo}</div>
                    </div>
                    <div className='rating-progress-row'>
                        <div className='rating'><StarFill /> <StarOutline /> <StarOutline /> <StarOutline /> <StarOutline /></div>
                        <div className='rating-progress'><ProgressBar variant='primary' now={userType === "provider" ? data?.starOne : data?.userStarOne} /></div>
                        <div className='progress-value'>{userType === "provider" ? data?.starOne : data?.userStarOne}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OverAllRating